
export const DjinniAPI = {

  selectAll() {
    return $cfg.API.get('/admin/djinni/select/all');
  },

  unchainBeast(data) {
    return $cfg.API.post('/admin/djinni/unchain-beast', data);
  },

  getLastSession() {
    return $cfg.API.get('/admin/djinni/last-session');
  },
}
